<template>
    <div class="time">
        <span class="iconBox">
            <i class="iconfont icon-shijian"></i>
        </span>
        <span class="timer">
            {{date}}
            <br />
            {{week}}&nbsp;&nbsp;&nbsp;&nbsp;{{time}}
        </span>
           
    </div>
</template>

<script>
import moment from "moment";
export default {
    name: "timer",
    data() {
        return {
            time: "",
            date: "",
            week: ""
        };
    },
    beforeMount() {
        moment.locale("zh-cn");
        setInterval(() => {
            let currentMoment = moment();
            this.time = currentMoment.format("HH:mm:ss");
            this.date = currentMoment.format("YYYY年MM月DD日");
            this.week = currentMoment.format("dddd");
        }, 1000);
    }
};
</script>

<style lang="less" scoped>
.time {
    float: left;
    width: 200px;
    margin-left: 10px;
    text-align: center;
    i {
        color: #2C54CE;
        padding-right: 5px;
        font-size: 30px;
        line-height: 50px;
    }
    span {
        display: block;
        height: 50px;
        text-align: right;
        color: #2C54CE;
        float: left;
        i{
            font-size: 40px;
        }
    }
    span.timer{
        margin-top: 6px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/main/components/time/moment.vue